import React from 'react';

function Register() {
  return (
    <div>
      <h1>Velkommen til Register</h1>
    </div>
  );
}

export default Register;
